import PropTypes from 'prop-types'
import React from 'react'
import { InputAdornment, Grid, Menu } from '@material-ui/core'
import { Search, Add, CloudDownload } from '@material-ui/icons'
import { TableControlsButtonGroup } from '../../../theme/Table'
import {
  svgIconStyle,
  StyledExternalLink,
  StyledButton,
  StyledSearchField,
  StyledMenuItem,
  colors
} from '../../../theme/Global'
import { CustomArrowDropDown, TableControls, TableLabel } from './styles'

const maxDropDownHeight = '40vh'

const TableControlRenderer = ({
  closeFilterDateMenu,
  closeFilterLocaleMenu,
  countries,
  eventFactory,
  exports,
  filterDateLabel,
  filterDateMenu,
  filterLocaleLabel,
  filterLocaleMenu,
  handleExports,
  handleSearch,
  openFilterDateMenu,
  openFilterLocaleMenu,
  recordCount,
  recordType,
  showDateFilter,
  showLocaleFilter,
  showSearch,
  stateList,
  showAddLocationButton,
  handleLocationAdd,
  isLoading
}) => (
  <TableControls>
    <Grid container>
      <Grid item xs={8}>
        <TableControlsButtonGroup>
          {showLocaleFilter ? (
            <React.Fragment>
              <StyledButton
                disabled={isLoading}
                onClick={openFilterLocaleMenu}
                style={{ float: 'left' }}
              >
                Filter By Locale
                {CustomArrowDropDown}
              </StyledButton>
              <Menu
                open={Boolean(filterLocaleMenu)}
                anchorEl={filterLocaleMenu}
                onClose={closeFilterLocaleMenu}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
                getContentAnchorEl={null}
                MenuListProps={{ style: { maxHeight: maxDropDownHeight } }}
              >
                <StyledMenuItem onClick={closeFilterLocaleMenu}>Clear Filter</StyledMenuItem>
                {stateList.map((item, index) => {
                  if (countries.includes(item.country)) {
                    return (
                      <StyledMenuItem
                        key={item.name}
                        onClick={eventFactory(closeFilterLocaleMenu, index)}
                      >
                        {item.name}
                      </StyledMenuItem>
                    )
                  }
                  return null
                })}
              </Menu>
            </React.Fragment>
          ) : null}
          {showDateFilter ? (
            <React.Fragment>
              <StyledButton onClick={openFilterDateMenu}>
                Range: {filterDateLabel}
                {CustomArrowDropDown}
              </StyledButton>
              <Menu
                anchorEl={filterDateMenu}
                open={Boolean(filterDateMenu)}
                onClose={closeFilterDateMenu}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
                getContentAnchorEl={null}
                MenuListProps={{ style: { maxHeight: maxDropDownHeight } }}
              >
                <StyledMenuItem onClick={eventFactory(closeFilterDateMenu, '30')}>30 days</StyledMenuItem>
                <StyledMenuItem onClick={eventFactory(closeFilterDateMenu, '60')}>60 days</StyledMenuItem>
                <StyledMenuItem onClick={eventFactory(closeFilterDateMenu, '90')}>90 days</StyledMenuItem>
                <StyledMenuItem onClick={eventFactory(closeFilterDateMenu, 'thisYear')}>
                  This Year
                </StyledMenuItem>
                <StyledMenuItem onClick={eventFactory(closeFilterDateMenu, '5year')}>5 Years</StyledMenuItem>
                <StyledMenuItem onClick={eventFactory(closeFilterDateMenu, 'custom')}>
                  Custom Date Range
                </StyledMenuItem>
              </Menu>
            </React.Fragment>
          ) : null}
          { !isLoading ? (
            <TableLabel>
              Showing {recordCount} {recordType}
              {filterLocaleLabel ? ` in ${filterLocaleLabel}` : null}
            </TableLabel>
          ) : null}
        </TableControlsButtonGroup>
      </Grid>
      <Grid item xs={4}>
        <Grid container justify="space-between" alignItems="center" spacing={8}>
          <Grid item xs={4}>
            {exports.length > 0 ? (
              <React.Fragment>
                <StyledButton
                  disabled={isLoading}
                  onClick={eventFactory(handleExports, 'csv')}
                >
                  CSV&nbsp; <CloudDownload />
                </StyledButton>
              </React.Fragment>
            ) : null}
          </Grid>
          {showAddLocationButton ? (
            <StyledExternalLink disabled={isLoading} onClick={(event) => handleLocationAdd(event)}>
              <Add /> Add Location
            </StyledExternalLink>
          ) : null}
          {showSearch ? (
            <Grid
              item
              xs={8}
              style={{ textAlign: 'right' }}
            >
              <StyledSearchField
                disabled={isLoading}
                placeholder="Search"
                onChange={handleSearch}
                margin="dense"
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (
                    <InputAdornment
                      position="start"
                      style={{ marginTop: '8px' }}
                    >
                      <Search style={svgIconStyle({
                        color: colors.mediumGrey,
                        height: '32px',
                        width: '32px'
                      })}
                      />
                    </InputAdornment>
                  )
                }}
                style={{
                  margin: '0 auto',
                  padding: '0'
                }}
              />
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  </TableControls>
)

TableControlRenderer.propTypes = {
  closeFilterDateMenu: PropTypes.func.isRequired,
  closeFilterLocaleMenu: PropTypes.func.isRequired,
  eventFactory: PropTypes.func.isRequired,
  exports: PropTypes.array.isRequired,
  filterDateLabel: PropTypes.string,
  filterDateMenu: PropTypes.object,
  filterLocaleLabel: PropTypes.string,
  filterLocaleMenu: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
  handleExports: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  openFilterDateMenu: PropTypes.func.isRequired,
  openFilterLocaleMenu: PropTypes.func.isRequired,
  recordCount: PropTypes.number.isRequired,
  recordType: PropTypes.string.isRequired,
  search: PropTypes.string,
  showDateFilter: PropTypes.bool.isRequired,
  showLocaleFilter: PropTypes.bool.isRequired,
  showSearch: PropTypes.bool.isRequired,
  handleLocationAdd: PropTypes.func.isRequired
}

TableControlRenderer.defaultProps = {
  filterDateLabel: '90 Days',
  filterDateMenu: null,
  filterLocaleLabel: '',
  filterLocaleMenu: null,
  search: ''
}

export default TableControlRenderer
